import {
  ArtworkApiDTO,
  // InferAttributesMediaUploaderFileApiDTODestinationClickupAllOf as DestinationClickup,
  InferAttributesMediaUploaderFileApiDTODestinationColdStorageAllOf as DestinationColdStorage,
  InferAttributesMediaUploaderFileApiDTODestinationDriveAllOf as DestinationDrive,
  InferAttributesMediaUploaderFileApiDTODestinationYoutubeChannelAllOf as DestinationYoutubeChannel,
  InferAttributesMediaUploaderFileApiDTODestinationYoutubeFootprintAllOf as DestinationFootprint,
} from '../codegen/generated/Api.schemas'

const BASE_URLS = {
  drive: 'https://drive.google.com/file/d/',
  footprint: 'https://studio.youtube.com/asset/',
  youtube: 'https://youtube.com/watch?v=',
  clickUp: 'https://app.clickup.com/t/',
  coldStorage: 'https://console.cloud.google.com/storage/browser/_details/',
}

const urlSafe = (str: string) => {
  return str.replaceAll('(', '%28').replaceAll(')', '%29')
}

export const DestinationsHelper = {
  getDriveURL: (fileId: DestinationDrive['driveFileId']) => {
    return urlSafe(`${BASE_URLS.drive}${fileId}/view`)
  },
  getFootprintURL: (
    youtubeAssetId: DestinationFootprint['youtubeAssetId'],
    footprintOwnerId: DestinationFootprint['onBehalfOfContentOwner'],
  ) => {
    return urlSafe(
      `${BASE_URLS.footprint}${youtubeAssetId}/metadata/overview?o=${footprintOwnerId}`,
    )
  },
  getYoutubeChannelURL: (youtubeVideoId: DestinationYoutubeChannel['youtubeVideoId']) => {
    return urlSafe(BASE_URLS.youtube + youtubeVideoId)
  },
  getClickUpPath: (clickupTaskId: ArtworkApiDTO['clickupTaskId']) => {
    return urlSafe(BASE_URLS.clickUp + clickupTaskId)
  },
  getColdStorageURL: (
    gcloudBucketName: DestinationColdStorage['gcloudBucketName'],
    gcloudFileName: DestinationColdStorage['gcloudFileName'],
  ) => {
    return urlSafe(
      `${BASE_URLS.coldStorage}${gcloudBucketName}/${gcloudFileName};tab=live_object?project=logicomix`,
    )
  },
}
